const termsDialogStyles = {
  dialogPaper: {
    borderRadius: "12px",
    maxWidth: "556px",
    maxHeight: "385px",
  },
  dialogTitleBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    py: "20px",
    px: { xs: "16px", sm: "24px" },
  },
  dialogTitle: {
    fontWeight: 600,
    fontSize: "18px",
    color: "rgba(47, 43, 61, 0.9)",
    flex: 1,
    p: 0,
  },
  closeIcon: {
    color: "rgba(62, 63, 76, 1)",
  },
  dialogContent: {
    pt: "32px !important",
    pb: "0px !important",
    mb: "15px",
    borderTop: "1px solid rgba(234, 234, 234, 1)",
    overflow: "hidden",
    display: "flex",
  },
  contentBox: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  headingText: {
    fontSize: "18px",
    fontWeight: 500,
    color: "rgba(47, 43, 61, 0.9)",
  },
  descriptionWrapper: {
    overflowY: "auto",
    overflowX: "hidden",
    flex: 1,
  },
  descriptionText: {
    fontSize: "15px",
    fontWeight: 400,
    pr: "4px",
    color: "rgba(47, 43, 61, 0.9)",
  },
  dialogActions: {
    paddingY: "12px",
    paddingX: "24px",
  },
  actionsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: { xs: "column", sm: "row" },
    columnGap: "24px",
    rowGap: "10px",
    width: "100%",
  },
  pauseText: {
    fontSize: "15px",
    fontWeight: 400,
    textDecoration: "underline",
    cursor: "pointer",
    color: "rgba(47, 43, 61, 0.9)",
  },
  acceptButton: {
    backgroundColor: "rgba(37, 124, 109, 1)",
    color: "white",
    fontSize: 15,
    fontWeight: 500,
    textTransform: "none",
    borderRadius: "8px",
    paddingX: "12px",
    paddingY: "8px",
    height: "39px",
    width: { xs: "100%", sm: "auto" },
    boxShadow: "none !important",
    "&:hover": { backgroundColor: "rgba(31, 106, 90, 1)" },
  },
};

export default termsDialogStyles;
